import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgOrganicIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    width="1em"
    height="1em"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g className="organic_svg__nc-icon-wrapper">
      <path
        d="M57.12 12.891a1 1 0 0 0-1.31-.534A57.124 57.124 0 0 0 45.642 18.2 34.259 34.259 0 0 1 49 32c0 8.651-4.258 16.093-10.32 19.306a10.887 10.887 0 0 0 1.685.884 11.025 11.025 0 0 0 4.182.815 13.317 13.317 0 0 0 6.634-1.883 19.5 19.5 0 0 0 8.1-9.641c4.802-11.808-1.875-27.911-2.161-28.59ZM6.88 12.891a1 1 0 0 1 1.31-.534A57.124 57.124 0 0 1 18.358 18.2 34.259 34.259 0 0 0 15 32c0 8.651 4.258 16.093 10.32 19.306a10.887 10.887 0 0 1-1.685.884 11.025 11.025 0 0 1-4.182.815 13.317 13.317 0 0 1-6.634-1.883 19.5 19.5 0 0 1-8.1-9.641C-.083 29.673 6.594 13.57 6.88 12.891Z"
        data-color="color-2"
      />
      <path d="M32 63a1 1 0 0 1-1-1v-8a1 1 0 0 1 2 0v8a1 1 0 0 1-1 1ZM32.731 2.317a1.033 1.033 0 0 0-1.462 0C30.687 2.942 17 17.77 17 32c0 10.049 6.2 18.279 14 18.936V35.459l-6.65-5.7a1 1 0 0 1 1.3-1.518L31 32.827V23a1 1 0 0 1 2 0v15.827l5.35-4.586a1 1 0 0 1 1.3 1.518l-6.65 5.7v9.477c7.805-.657 14-8.887 14-18.936C47 17.77 33.313 2.942 32.731 2.317Z" />
    </g>
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgOrganicStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgOrganicIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const OrganicIcon: any = SvgOrganicStyle;
export default OrganicIcon;
